/**
 * 百度统计 H5 端模块
 *
 * 策略：后端配置驱动
 * - baiduHmUrl 来自后端 /newapi/site/site/getInfo 接口
 * - 如果存在且有值，动态注入 hm.js 脚本
 * - PV 上报由百度统计后台 SPA 开关自动处理，不手动调用 _trackPageview
 * - 仅提供自定义事件上报 API
 */

declare global {
  interface Window {
    _hmt?: any[]
  }
}

let initialized = false;

/**
 * 初始化百度统计 (动态注入 hm.js)
 * @param baiduHmUrl - 后端接口返回的完整 hm.js URL，为空则不启用统计
 */
export function initBaiduTongji(baiduHmUrl?: string): void {
  if (initialized) return;
  // baiduHmUrl 来自后端接口，为空则不启用统计
  if (!baiduHmUrl) {
    console.warn('[BaiduTongji] baiduHmUrl 为空，统计未启用');
    return;
  }

  window._hmt = window._hmt || [];
  const script = document.createElement('script');
  script.async = true;
  script.src = baiduHmUrl;
  script.onload = () => console.log('[BaiduTongji] hm.js 加载成功:', baiduHmUrl);
  document.head.appendChild(script);
  initialized = true;
}

/**
 * 上报自定义事件 (H5)
 * @param category - 事件分类
 * @param action - 事件动作
 * @param label - 事件标签
 * @param value - 事件数值
 */
export function trackEvent(category: string, action: string, label?: string, value?: number): void {
  if (!initialized || !window._hmt) return;
  window._hmt.push(['_trackEvent', category, action, label || '', value || 0]);
}

/** 是否已初始化 */
export function isBaiduTongjiReady(): boolean {
  return initialized;
}
